document.addEventListener('DOMContentLoaded', function () {
    var serialInputs = document.querySelectorAll('.serial-validation');

    serialInputs.forEach(function (input) {
        // Prevent invalid characters on input
        input.addEventListener('input', function () {
            this.value = this.value.replace(/[^A-Za-z0-9\-\/._#]/g, '');
        });

        // Prevent pasting invalid characters
        input.addEventListener('paste', function (e) {
            e.preventDefault();

            var paste = (e.clipboardData || window.clipboardData).getData('text');

            // Allow only A-Z, a-z, 0-9, -, /, ., _, #
            var cleaned = paste.replace(/[^A-Za-z0-9\-\/._#]/g, '');

            // Insert cleaned text at cursor position
            var start = input.selectionStart;
            var end = input.selectionEnd;
            var currentValue = input.value;

            input.value = currentValue.substring(0, start) + cleaned + currentValue.substring(end);

            // Move the cursor after the inserted text
            input.setSelectionRange(start + cleaned.length, start + cleaned.length);
        });
    });
});